import { useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'

import { premiumCurrencyDialogAtom } from '../../atom/premium-currency-dialog'

import { PremiumCurrencyDialog } from './premium-currency-dialog'

export const PremiumCurrencyDialogController = () => {
  const [premiumCurrencyDialog, setPremiumCurrencyDialog] = useAtom(
    premiumCurrencyDialogAtom,
  )
  return (
    <AnimatePresence>
      {premiumCurrencyDialog ? (
        <PremiumCurrencyDialog
          open={!!premiumCurrencyDialog}
          onOpenChange={() => setPremiumCurrencyDialog(undefined)}
          currency={premiumCurrencyDialog}
        />
      ) : undefined}
    </AnimatePresence>
  )
}
